import TraitsListPopupContent from './TraitsListPopupContent'

export default TraitsListPopupContent
